export default __webpack_public_path__ + "static/media/goal6.c8253c08.webp";